import React from 'react'
import {useDispatch} from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import {CLOSE_DRAW_CONTROL_POPUP} from '../../constants/action-types'

export default function ControlClose() {
    const dispatch = useDispatch()

    const hidePopup = () => {
        dispatch({type: CLOSE_DRAW_CONTROL_POPUP})
    }

    return (
        <div className="panel-popup__close">
            <IconButton onClick={hidePopup}>
                <CloseIcon />
            </IconButton>
        </div>
    )
}
